import React from 'react';
import { Dropdown } from 'antd';

/**
 * Type fixes for antd 4.9.0 incomplete TypeScript definitions
 * 
 * antd 4.9.0 has some missing props in its TypeScript definitions
 * that are actually supported at runtime. These types extend the
 * original antd types to include the missing properties.
 */

// Fix for Dropdown component - missing children prop
export type DropdownWithChildren = React.ComponentType<
  React.ComponentProps<typeof Dropdown> & { children: React.ReactNode }
>;

export const FixedDropdown = Dropdown as DropdownWithChildren;

// Add other antd component fixes here as needed
// Example: export type MenuWithSomeFixedProp = ...
